import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Box, Chip, Grid, IconButton, Modal, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { SAVE_CLIENT_COMMUNICATOR_ACKNOWLEDGEMENTS } from "../../constant/Apipath";
import { BIBlack, BIBlue, BIGrey, BILightGrey } from "../../assets/helpers";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function ViewCommunicator({ open, handleClose, shareData }) {
  const [loading, setLoading] = useState(false);
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientCommunicatorViewModal(
    multiLanguageData?.ClientCommunicatorViewModal || {}
  );
  const { TEXT_ACKNOWLEDGE, TEXT_ACKNOWLEDGED } = LANGUAGE;

  const saveClientCommunicatorAcknowledgements = async () => {
    try {
      setLoading(true);
      let obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            acknowledged: 0,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            ClientCommunicatorId: shareData.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const isAcknowledgementSent = await Postrequestcall(
        SAVE_CLIENT_COMMUNICATOR_ACKNOWLEDGEMENTS,
        obj,
        loginData?.accessToken
      );
      if (isAcknowledgementSent) {
        setLoading(false);
        handleClose(true);
      }
      setLoading(false);
    } catch (error) {
      console.log("saveClientCommunicatorAcknowledgements-> Error When Acknowleding Client Communicator: ", error);
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-view-client-support"
      aria-describedby="modal-view-client">
      <Box marginTop={2} borderRadius={2} className="client-modal-responsive">
        <Grid className="view-header" container spacing={1}>
          <Grid size={12} sx={{display:'flex'}}  justifyContent={'space-between'} alignItems={'center'}>
            <Typography fontWeight={"bold"} sx={{ color: BIBlack }} fontSize={20}>
              {shareData.subject}
            </Typography>
            <IconButton className="view-close" sx={{ color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }}  onClick={handleClose}>
              <CloseIcon  />
            </IconButton>
          </Grid>
          <Chip
              sx={{
                borderRadius: "12px",
              }}
              label={shareData.clientCommunicatorCategory}
            />

          {/* </Grid> */}
          <Grid size={12}>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              width="100%">
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Avatar src={shareData.profilePictureUrl} />
                <Typography variant="body1">{shareData.userName}</Typography>
              </Box>
              <Typography variant="body1" gutterBottom color={BIGrey}>
                {dayjs(shareData.date).format("MMMM DD, YYYY")}
              </Typography>
            </Box>
          </Grid>

          <Grid size={12}>
            <Typography variant="body1" gutterBottom>
              {shareData.body}
            </Typography>
          </Grid>
          <Grid size={12}>
            <LoadingButton
              startIcon={<></>}
              disabled={shareData.acknowledged === 1 ? true : false}
              fullWidth
              onClick={saveClientCommunicatorAcknowledgements}
              sx={{
                textTransform: "none",
                boxShadow: "none",
                borderRadius: "12px",
                backgroundColor:
                  shareData.acknowledged === 1 ? "lightGrey" : selectedClientData?.AccentColor,
                color: "white"
              }}
              loadingPosition="start"
              loading={loading}>
              {shareData.acknowledged === 1 && <CheckIcon />}
              {shareData.acknowledged === 1 ? TEXT_ACKNOWLEDGED : TEXT_ACKNOWLEDGE}
            </LoadingButton>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ViewCommunicator;
